import { createStore } from 'vuex'
import { Errors, Links, ModuleStruct, Stats, User } from "@/api/types";
import { blankUser } from "@/constants";

export type ErrorDef = {
    message: string | null,
    errors: Errors
}

export type State = {
    user: User
    error: ErrorDef
    moduleStruct: ModuleStruct[],
    stats: Stats,
    links: Links,
    referral: string
}

export default createStore<State>({
    state: {
        user: blankUser,
        moduleStruct: [],
        error: { message: null, errors: {} },
        stats: { users: 0, downloads: [], total_downloads: 0, launches: [], total_launches: 0, version: '', version_advanced: '' },
        links: { discord: 'https://discord.com' },
        referral: ''
    },
    mutations: {
        setUser(state: State, user: User) {
            if (user.access === 1 || user.access > 2) {
                user.owned = true;
            }
            state.user = user;
        }
    },
    modules: {}
})
